'use client'

import type { UseProductSimpleListProps } from '@maestro/commerce-blocks/components/product-simple-list/product-simple-list.types'
import type { Product } from '@maestro/data-layer'

import { useCallback, useRef } from 'react'

import { useGlobalContext } from '@maestro/commerce-blocks/context/global.context'
import { useProductViewTracking } from '@maestro/commerce-blocks/hooks/use-product-view-tracking'
import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventPayloadType, EventType } from '@maestro/data-layer'

export const useProductSimpleList = (props: UseProductSimpleListProps) => {
  const { products, eventListProps } = props
  const { publish } = useEventBusContext()
  const { session } = useMaestroSession()
  const { searchProductIndex } = useGlobalContext()
  const containerRef = useRef<HTMLUListElement>(null)

  const onPublish = useCallback(
    (visibleProducts: { product: Product; position: number }[]) => {
      const payload: EventPayloadType[EventType.PRODUCT_LIST_VIEWED] = {
        items: visibleProducts.map(({ product, position }) => ({
          product,
          quantity: 1,
          position,
        })),
        listId: eventListProps.listId,
        listName: eventListProps.listName || '',
        listType: eventListProps.listType || '',
        authenticatedUserToken: session?.user?.hashedEmail ?? '',
        searchServiceIndex: searchProductIndex,
      }

      publish<EventPayloadType[EventType.PRODUCT_LIST_VIEWED]>(
        EventType.PRODUCT_LIST_VIEWED,
        payload
      )
    },
    [eventListProps, publish, searchProductIndex, session?.user?.hashedEmail]
  )

  useProductViewTracking({
    containerRef,
    products,
    onPublish,
  })

  return {
    containerRef,
  }
}
